import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { IsOptional, IsString, IsUUID, IsObject, IsEnum } from 'class-validator'
import { ActivityVisibility } from '../../../enums'

export class CreateTemplateDto {
  @ApiProperty({ description: 'Nom du gabarit' })
  @IsString()
  name!: string

  @ApiPropertyOptional({ description: 'Description du gabarit', type: 'string' })
  @IsOptional()
  @IsString()
  description?: string

  @ApiProperty({ description: "Type d'activité", format: 'uuid' })
  @IsUUID('4')
  typeId!: string

  @ApiProperty({ description: 'Contenu initial (seed)', type: Object })
  @IsObject()
  seedContent!: Record<string, any>

  @ApiPropertyOptional({
    description: 'Configuration du gabarit',
    type: Object,
  })
  @IsOptional()
  @IsObject()
  config?: Record<string, any>

  @ApiPropertyOptional({
    description: 'Propriétaire explicite',
    format: 'uuid',
  })
  @IsOptional()
  @IsUUID('4')
  ownerUserId?: string

  @ApiPropertyOptional({
    description: 'Visibilité du gabarit',
    enum: ActivityVisibility,
  })
  @IsOptional()
  @IsEnum(ActivityVisibility)
  visibility?: ActivityVisibility
}
